<template>
  <div></div>
</template>

<script>
export default {
  name: "PipeNews",

  mounted() {
    console.log("--------- Pipeline Step News ----------");
    this.$store.dispatch("news/fetchNews").finally(() => {
      if (this.$store.getters["news/unreadMessagesAvailable"]) {
        this.$store.commit("news/setAutoOpenNewsCenter", true);
        this.$bvModal.show("modal-news-center");
        return;
      }
      this.$store.commit("popups/setNextPipelineQueueStep");
    });
  },
};
</script>

<style scoped lang="scss"></style>
